import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@brent/core-ui/ui'
import type { QuestionOption, VoteResults as VoteResultsType } from '@/services/api/questions'

interface VoteResultsProps {
  options: QuestionOption[]
  results: VoteResultsType
}

export default function VoteResults({ options, results }: VoteResultsProps) {
  const maxCount = Math.max(...Object.values(results.results), 1)

  return (
    <Card>
      <CardHeader>
        <CardTitle>Results</CardTitle>
        <CardDescription>
          {results.total_votes} {results.total_votes === 1 ? 'vote' : 'votes'} cast
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {options.map((option) => {
          const count = results.results[option.id] ?? 0
          const percentage =
            results.total_votes > 0 ? Math.round((count / results.total_votes) * 100) : 0
          const barWidth = maxCount > 0 ? (count / maxCount) * 100 : 0

          return (
            <div key={option.id} className="space-y-1">
              <div className="flex justify-between text-sm">
                <span>{option.text}</span>
                <span className="text-muted-foreground">
                  {count} ({percentage}%)
                </span>
              </div>
              <div className="h-3 rounded-full bg-muted overflow-hidden">
                <div
                  className="h-full rounded-full bg-primary transition-all duration-500"
                  style={{ width: `${barWidth}%` }}
                />
              </div>
            </div>
          )
        })}
      </CardContent>
    </Card>
  )
}
